import { gatewayApi } from './apiService';

const BASE = '/talent-service/talent-favorites';

const talentFavoritesService = {
  // --- списки ---
  async listLists(userId) {
    const response = await gatewayApi.get(`${BASE}/lists`, {
      params: userId ? { user_id: userId } : {},
    });
    return response.data;
  },

  async createList(payload) {
    const response = await gatewayApi.post(`${BASE}/lists`, payload);
    return response.data;
  },

  async updateList(id, payload) {
    const response = await gatewayApi.put(`${BASE}/lists/${id}`, payload);
    return response.data;
  },

  async deleteList(id) {
    const response = await gatewayApi.delete(`${BASE}/lists/${id}`);
    return response.data;
  },

  async listTalents(listId, params = {}) {
    const response = await gatewayApi.get(`${BASE}/lists/${listId}/talents`, { params });
    return response.data;
  },

  async owners() {
    const response = await gatewayApi.get(`${BASE}/owners`);
    return response.data;
  },

  // --- отметки ---
  /** Плоский дамп всех отметок: фронт строит из него Map и не ходит за каждой строкой. */
  async myFavoritesFlat(userId) {
    const response = await gatewayApi.get(BASE, {
      params: { flat: 1, ...(userId ? { user_id: userId } : {}) },
    });
    return response.data;
  },

  async listsOfTalent(talentId, userId) {
    const response = await gatewayApi.get(BASE, {
      params: { talent_id: talentId, ...(userId ? { user_id: userId } : {}) },
    });
    return response.data;
  },

  async toggle(talentId, listId = null) {
    const response = await gatewayApi.post(`${BASE}/toggle`, {
      talent_id: talentId,
      ...(listId ? { list_id: listId } : {}),
    });
    return response.data;
  },

  async setLists(talentId, listIds) {
    const response = await gatewayApi.put(`${BASE}/talents/${talentId}/lists`, { list_ids: listIds });
    return response.data;
  },

  async lookup(talentIds, userId) {
    const response = await gatewayApi.post(`${BASE}/lookup`, {
      talent_ids: talentIds,
      ...(userId ? { user_id: userId } : {}),
    });
    return response.data;
  },

  async removeItem(id) {
    const response = await gatewayApi.delete(`${BASE}/${id}`);
    return response.data;
  },
};

export default talentFavoritesService;
